(() => {

    console.log('test');
    const hook = setInterval(() => {
        let hulkReviews = document.querySelector('#hulk__product-review');
        if (hulkReviews && document.readyState === 'complete') {
            clearInterval(hook);
            adjustHulkReviews();
            setTimeout(createCustomScroll,2500);
        }
    }, 50);
    setTimeout(() => {
        clearInterval(hook);
    }, 10000);



    function adjustHulkReviews() {
        const hook = setInterval(() => {
            try {
                const reviewTab = document.querySelector('#hulk__product-review a.hulk-review-tab.hulk-tab-active');
                reviewTab.textContent = reviewTab.textContent.replace(/[^a-zA-Z]/g, '');
            }
            catch { }
        },50);
        setTimeout(() => {
            clearInterval(hook);
        }, 10000);
    }

    function createCustomScroll(){
      if(!(window.innerWidth < 750)) return;
      if(document.querySelector('[data-hulk-review-listing]')){
        const iconL = document.createElement('span');
        iconL.textContent = '<';
        iconL.setAttribute('data-action','left');
        iconL.classList.add('custom_scroll','cs_left');
        const iconR = document.createElement('span');
        iconR.textContent = '>';
        iconR.setAttribute('data-action','right');
        iconR.classList.add('custom_scroll','cs_right');
        document.querySelector('[data-hulk-review-listing]').appendChild(iconL);
        document.querySelector('[data-hulk-review-listing]').appendChild(iconR);
        document.querySelectorAll('[data-hulk-review-listing] .custom_scroll').forEach((node)=>node.addEventListener('click',handleScrollAction));
        document.querySelector('[data-hulk-review-listing]').querySelector('.item:first-child').classList.add('custom_isVisible');
      } else createCustomScroll();
    }

    function handleScrollAction(event){
      let current = document.querySelector('.custom_isVisible');
      if (event.target.getAttribute('data-action') == 'left' && current.previousElementSibling?.classList.contains('item')){
        current.previousElementSibling.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        })
        current.classList.remove('custom_isVisible');
        current.previousElementSibling.classList.add('custom_isVisible');
      }
      if (event.target.getAttribute('data-action') == 'right' && current.nextElementSibling?.classList.contains('item')){
        current.nextElementSibling.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        })
        current.classList.remove('custom_isVisible');
        current.nextElementSibling.classList.add('custom_isVisible');
      }
      
    }

})()